import { useCallback } from 'react';

export default function useToast() {
	const notyView = useCallback((data) => {
		(async () => {
			const { default: Noty } = await import('noty');
			await import('app/assets/scss/component/noty.css');
			new Noty(data).show().setTimeout(data.timeout || 5000);
		})();
	}, []);
	return {
		notyView,
	};
}
